import React from 'react'
import PropTypes from 'prop-types'
import {Link, useLocation} from "react-router-dom"
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export function BackButton({to, isMobileDevice, iconOnly}) {
    const context = useI18nContext()

    const location = useLocation()
    const buttonDescription = getI18nTextWithContext(context, 'common.back')


    return <Link
            to={{ pathname: to, search: location.search }}
            className={'btn btn-secondary' + (isMobileDevice ? ' btn-block' : '') + (iconOnly ? ' round' : '')}
            data-test-id="80100345-ad6c"
            aria-label={buttonDescription}
        >
            {iconOnly ? (
                <svg className="back-arrow-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="icon" d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"/>
                </svg>
            ) : (buttonDescription)}
    </Link>
}

BackButton.propTypes = {
    to: PropTypes.string.isRequired,
    isMobileDevice: PropTypes.bool,
    iconOnly: PropTypes.bool
}

export default BackButton
